export default {
	ADD_STATUS(state, item) {
		state.status.push(item);
	},
	SET_STATUS(state, status) {
		state.status = status;
		state.totalStatus = status.length;
	},
	SET_RESOURCES(state, resources) {
		state.resources = resources;
		let newData = resources.map((el) => {
			return {value: el.id, label: el.name};
		});
		state.resourcesForSelect = newData;
	},
	// SET_LABELS(state, labels) {
	//   state.eventLabels = labels
	// },
	UPDATE_STATUS(state, product) {
		const productIndex = state.status.findIndex((p) => p.id === product.id);
		Object.assign(state.status[productIndex], product);
	},
	REMOVE_STATUS(state, itemId) {
		const ItemIndex = state.status.findIndex((p) => p.id === itemId);
		state.status.splice(ItemIndex, 1);
	},
};
